import { ensureQueryFn as T, addToStart as j, addToEnd as E } from "./contact-channels71.js";
function S(t) {
  return {
    onFetch: (e, s) => {
      var p, h, y, F, b;
      const r = e.options, d = (y = (h = (p = e.fetchOptions) == null ? void 0 : p.meta) == null ? void 0 : h.fetchMore) == null ? void 0 : y.direction, c = ((F = e.state.data) == null ? void 0 : F.pages) || [], m = ((b = e.state.data) == null ? void 0 : b.pageParams) || [];
      let o = { pages: [], pageParams: [] }, g = 0;
      const f = async () => {
        let i = !1;
        const u = (a) => {
          Object.defineProperty(a, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? i = !0 : e.signal.addEventListener("abort", () => {
              i = !0;
            }), e.signal)
          });
        }, k = T(e.options, e.fetchOptions), v = async (a, n, l) => {
          if (i)
            return Promise.reject();
          if (n == null && a.pages.length)
            return Promise.resolve(a);
          const P = {
            client: e.client,
            queryKey: e.queryKey,
            pageParam: n,
            direction: l ? "backward" : "forward",
            meta: e.options.meta
          };
          u(P);
          const O = await k(
            P
          ), { maxPages: w } = e.options, q = l ? j : E;
          return {
            pages: q(a.pages, O, w),
            pageParams: q(a.pageParams, n, w)
          };
        };
        if (d && c.length) {
          const a = d === "backward", n = a ? N : K, l = {
            pages: c,
            pageParams: m
          }, P = n(r, l);
          o = await v(l, P, a);
        } else {
          const a = t ?? c.length;
          do {
            const n = g === 0 ? m[0] ?? r.initialPageParam : K(r, o);
            if (g > 0 && n == null)
              break;
            o = await v(o, n), g++;
          } while (g < a);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var i, u;
        return (u = (i = e.options).persister) == null ? void 0 : u.call(
          i,
          f,
          {
            client: e.client,
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          s
        );
      } : e.fetchFn = f;
    }
  };
}
function K(t, { pages: e, pageParams: s }) {
  const r = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[r],
    e,
    s[r],
    s
  ) : void 0;
}
function N(t, { pages: e, pageParams: s }) {
  var r;
  return e.length > 0 ? (r = t.getPreviousPageParam) == null ? void 0 : r.call(t, e[0], e, s[0], s) : void 0;
}
export {
  S as infiniteQueryBehavior
};
//# sourceMappingURL=contact-channels117.js.map
